import { FormControl, ValidatorFn } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class HospitalContactNameErrorStateMatcher implements ErrorStateMatcher {
  constructor(private readonly field: string) {}

  isErrorState(control: FormControl | null): boolean {
    return !!control?.enabled && control.touched &&
      (control.invalid || !!control.parent?.getError('duplicateContactNames')?.[this.field]);
  }
}

export const hospitalContactNameLabels: Record<string, string> = {
  hospitalAdminName: 'Hospital Administrator',
  chiefNurseName: 'Chief Nursing Officer/Nurse Executive',
  nurseManagerName: 'Nurse Manager',
  directCareName: 'Direct Care Co-Chair',
  emergencyDepartmentDirectorName: 'Emergency Department Director',
  technicalManagerCoChairName: 'Professional/Technical Manager Co-Chair',
  technicalStaffCoChairName: 'Professional/Technical Staff Co-Chair',
  serviceStaffingCommitteeManagerCoChairName: 'Service Staffing Committee Manager Co-Chair',
  serviceStaffingCommitteeStaffCoChairName: 'Service Staffing Committee Staff Co-Chair'
};

export function hospitalContactNamesValidator(bypass: () => boolean): ValidatorFn {
  return form => {
    if (bypass()) return null;

    const names = Object.keys(hospitalContactNameLabels).map(field => ({
      field,
      name: form.get(field)?.enabled
        ? (form.get(field)?.value ?? '').trim().replace(/\s+/g, ' ').toLowerCase()
        : ''
    }));
    const duplicates: Record<string, string[]> = {};
    names.forEach((left, index) => {
      names.slice(index + 1).forEach(right => {
        if (!left.name || left.name !== right.name) return;
        if (left.field === 'chiefNurseName' && right.field === 'nurseManagerName') return;
        (duplicates[left.field] ??= []).push(hospitalContactNameLabels[right.field]);
        (duplicates[right.field] ??= []).push(hospitalContactNameLabels[left.field]);
      });
    });
    return Object.keys(duplicates).length ? { duplicateContactNames: duplicates } : null;
  };
}
